import Dexie from 'dexie';

// Local mirror of server entities (sections/rooms/equipments/usages) plus an
// append-only sync queue. Entities mirror the server document shape exactly,
// with one extra bookkeeping field `_syncStatus` ('pending' | 'synced' | 'error')
// that must be stripped before sending a record to the API.
export const db = new Dexie('walter_offline');

db.version(1).stores({
    sections: '_id, id_building, _syncStatus',
    rooms: '_id, id_section, _syncStatus',
    equipments: '_id, location.room_id, location.section_id, _syncStatus',
    usages: '_id, _id_equipement, _syncStatus',
    syncQueue: '++seq, entityType, entityId, status, createdAt',
    meta: 'key',
});

export default db;
